import { PageHeader } from '@/components/ui/PageHeader';
import { RoleCreateButton, RoleTable } from '@/features/users/RoleTable';

export function SystemRolesPage() {
  return (
    <div className="space-y-8 animate-in fade-in slide-in-from-bottom-4 duration-500">
      <PageHeader
        title="Roles"
        description="Roles available to every tenant: the 3 seeded roles, plus any system role you've created."
        action={<RoleCreateButton />}
      />
      <RoleTable />
    </div>
  );
}
